import { FormControl, FormHelperText } from '@material-ui/core';
import { Field, useField } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormContent } from 'app/pages/Registration/interfaces';
import {
  StyledFormControlLabel,
  StyledSwitch,
} from 'app/components/CheckBox/styles';

import { StyledFormControl, StyledFormLabel } from '../styles';

const CheckBox: React.FC<{
  path: string;
  label: string;
  labelNode?: React.ReactNode;
  options?: FormContent[];
}> = ({ labelNode, options, path, label }) => {
  const { t } = useTranslation();
  const [field, { touched, error }] = useField<boolean>({
    name: `${path}.${label}`,
    type: 'checkbox',
  });
  return (
    <>
      <FormControl
        error={error !== undefined}
        fullWidth
        className="form-field__max-width"
      >
        <StyledFormControlLabel
          label={
            labelNode !== undefined
              ? labelNode
              : t(`registration.component.checkbox.${label}.label`)
          }
          labelPlacement="start"
          control={
            <StyledSwitch $checked={field.checked}>
              <Field type="checkbox" {...field} />
              <span className="button-root">
                <span className="button-base" />
              </span>
            </StyledSwitch>
          }
        />
        {error !== undefined && touched && (
          <FormHelperText>{error}</FormHelperText>
        )}
      </FormControl>
      {field.checked && options !== undefined && (
        <StyledFormControl>
          <StyledFormLabel>
            {t(`registration.component.checkbox.${label}.subLabel`)}
          </StyledFormLabel>
          {options?.map((option) => (
            <CheckBox path={path} label={option.label} />
          ))}
          {error !== undefined && touched !== undefined && (
            <FormHelperText>{error}</FormHelperText>
          )}
        </StyledFormControl>
      )}
    </>
  );
};

export default CheckBox;
